import React, { useState } from 'react'
import Layout from '../../Components/Layout';
import { jwtDecode } from "jwt-decode";
import Annexures from './Annexures';
import SalaryComponent from './SalaryComponent';


export const getUserRole = (token) => {
    try {
        const decoded = jwtDecode(token);
        console.log("Decoded JWT:", decoded);

        const roles = decoded.roles || [];   // roles array from token
        const userName = decoded.userName || decoded.sub || null; // subject claim

        // Expiration (exp is in seconds, convert to ms)
        const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

        return { roles, userName, expiryTime };
    } catch (error) {
        console.error("Invalid token", error);
        return { roles: [], userName: null, expiryTime: null };
    }
};

const AnnexureSalary = () => {
   const token = localStorage.getItem("token");
      const { roles = [] } = getUserRole(token);
  
  
      const isEmployee = roles.includes("ROLE_EMP");
      const isManager = roles.includes("ROLE_MANAGER");
      const isAdmin = roles.includes("ROLE_ADMIN");
  
  
      const [activeTab, setActiveTab] = useState(
          isAdmin ? "annexures" : "salary-component"
      );
  return (
      <Layout>
           <div className="backgound-main-content">
  <div className="leave-management-container">


                    <ul
                        className="nav nav-tabs  d-flex align-items-center justify-content-between mb-4"
                        style={{
                            borderBottom: " 1px solid #DBDBDB",
                        }}
                    >
                        <div className="d-flex">
                            {(isEmployee || isManager) && (
                                <li className="nav-item">
                                    <button
                                        className="nav-link fw-semibold px-3"
                                        onClick={() => setActiveTab("annexures")}
                                        style={{
                                            backgroundColor: "transparent",
                                            border: "none",
                                            borderBottom:
                                                activeTab === "annexures"
                                                    ? "3px solid #00AFEF"
                                                    : "3px solid transparent",
                                            color: activeTab === "annexures" ? "#00AFEF" : "#909090",
                                            fontSize: "16px",
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        Annexures
                                    </button>
                                </li>
                            )}

                            {(isManager || isAdmin) && (
                                <li className="nav-item ms-3">
                                    <button
                                        className="nav-link fw-semibold px-3"
                                        onClick={() => setActiveTab("salary-component")}
                                        style={{
                                            backgroundColor: "transparent",
                                            border: "none",
                                            borderBottom:
                                                activeTab === "salary-component"
                                                    ? "3px solid #00AFEF"
                                                    : "3px solid transparent",
                                            color: activeTab === "salary-component" ? "#00AFEF" : "#909090",
                                            fontSize: "16px",
                                            transition: "all 0.3s ease",
                                        }}
                                    >
                                        SalaryComponent
                                    </button>
                                </li>
                            )}
                        </div>

                    </ul>



                    {/* 🔵 Tab Content */}
                    <div className="tab-content ">
                        {(isEmployee || isManager) && activeTab === "annexures" && (
                            <div className="tab-pane fade show active">
                                <Annexures />
                            </div>
                        )}

                        {(isManager || isAdmin) && activeTab === "salary-component" && (
                            <div className="tab-pane fade show active">
                                <SalaryComponent />
                            </div>
                        )}
                    </div>
                </div>
           </div>
        
      </Layout>
  )
}

export default AnnexureSalary